import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  position: relative;
  padding-bottom: 80px;
`

export const Logo = styled.img`
  align-self: center;
  margin-bottom: 16px;
  @media (max-width: 768px) {
      width: 100%;
    }
`

export const Form = styled(motion.form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px;
  @media (max-width: 768px) {
      gap: 16px;
    }

  button:first-of-type {
    margin-top: auto;
  }
  @media (min-width: 1170px) {
    margin: 0 auto;
    max-width: 80%;
    justify-content: center;
    button:first-of-type {
      margin: 2rem 0;
    }
  }
`

export const Wrapper = styled.div`
  ${({ theme }) => css`
    @media (max-width: 768px) {
      margin-top: auto;
    }
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 5rem;
  `}
`

export const Link = styled.a`
  ${({ theme }) => css`
    color: #FFFFFF;
    font-size: 12px;
    line-height: ${theme.spacing.stack.xxs};
    text-decoration: none;
    cursor: pointer;
    align-self: flex-end;
    @media (min-width: 1170px) {
      font-size: 16px;
    }
  `}
`
export const SignupText = styled.p`
  ${({ theme }) => css`
    text-align: center;
    font-size: 12px;
    margin-bottom: ${theme.spacing.stack.xxs};
    @media (min-width: 1170px) {
      font-size: 16px;
    }
    line-height: ${theme.spacing.stack.xxs};
  `}
`

export const CustomButton = styled.button`
  ${({ theme }) => css`
    background: #CC92FE;
    border: none;
    border-radius: 16px;
    color: #080322;
    padding: 12px;
    font-size: 16px;
    font-weight: 700;
    width: 100%;
    cursor: pointer;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.9;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

  @media (min-width: 768px) {
    margin-bottom: .7em;
  }
  `}
`

export const CustomButton2 = styled.button`
  ${({ theme }) => css`
    background: transparent;
    border: 1px solid #A9E8FC;
    border-radius: 16px;
    color: #A9E8FC;
    padding: 12px;
    font-size: 16px;
    font-weight: 700;
    width: 100%;
    cursor: pointer;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.9;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `}
`

export const WelcomeText = styled.p`
  ${({ theme }) => css`
    text-align: center;
    color: #CC92FE;
    font-size: 24px;
    font-weight: 700;
    line-height: 12px;
  `}
`
export const WelcomeText2 = styled.p`
  ${({ theme }) => css`
    text-align: center;
    margin-top: 10px;
    color: #9B96A7;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  `}
`

export const ImageButton = styled.button`
  ${({ theme }) => css`
    background: transparent;
    border: none;
    padding: 8px;
    cursor: pointer;
    transition: transform 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      transform: scale(1.1);
    }

    &:active {
      transform: scale(0.95);
    }
  `}
`

export const ImageButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 16px;
`

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 0;
  position: absolute;
  bottom: 0;
  left: 0;
`

export const FooterText = styled.p`
  ${({ theme }) => css`
    color: #9B96A7;
    font-size: 14px;
    text-align: center;
  `}
`
